import axios from 'axios';
import config from '../../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../../core/modules/common/tools/URLTools';

const apiFetchResdit7421PerformanceCarrier = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getResdit7421PerformanceCarrier',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchResdit7421PerformanceCarrier;
